import "./instrument";
import { Global } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { globalCss } from "./design/globalCss.ts";
import { theme } from "./design/theme.ts";
import { ConfigProvider } from "./components/contexts/WithConfig/ConfigProvider.tsx";
import * as Sentry from "@sentry/react";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Global styles={globalCss} />
    <MuiThemeProvider theme={theme}>
      <ConfigProvider>
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
          <App />
        </Sentry.ErrorBoundary>
      </ConfigProvider>
    </MuiThemeProvider>
  </StrictMode>,
);
